// Originally generated from weborder.json (OpenAPI). Hand-edited since —
// e.g. `InsuredAuthSessionResponse` was extended to read `name`,
// `username`, `firstname`, `lastname` which the backend ships but the spec
// schema omits. If you re-run scripts/gen-dtos.py, re-apply those fields
// (and update the spec to match) before committing.
// Domain: auth

import { OpenOrdersResponse } from "./insured.dto.js";

export class InsuredAuthSessionResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.type = raw.type ?? "";
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {number} */
    this.submissionId = raw.submissionId ?? 0;
    /** @type {OpenOrdersResponse[]} */
    this.openOrders = Array.isArray(raw.openOrders) ? raw.openOrders.map((x) => new OpenOrdersResponse(x)) : [];
    /** @type {string} */
    this.abbreviation = raw.abbreviation ?? "";
    /** @type {number} */
    this.refreshTokenExpirationTime = raw.refreshTokenExpirationTime ?? 0;
    /** @type {string} */
    this.name = raw.name ?? "";
    /** @type {string} */
    this.username = raw.username ?? "";
    /** @type {string} */
    this.firstname = raw.firstname ?? "";
    /** @type {string} */
    this.lastname = raw.lastname ?? "";
  }
}

export class InsuredAuthToken {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.type = raw.type ?? "";
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {number} */
    this.submissionId = raw.submissionId ?? 0;
    /** @type {OpenOrdersResponse[]} */
    this.openOrders = Array.isArray(raw.openOrders) ? raw.openOrders.map((x) => new OpenOrdersResponse(x)) : [];
    /** @type {string} */
    this.abbreviation = raw.abbreviation ?? "";
    /** @type {number} */
    this.refreshTokenExpirationTime = raw.refreshTokenExpirationTime ?? 0;
  }
}

/**
 * SSP web-order login. **username** is the insured email. **password** must
 * satisfy the regex: at least 6 characters, uppercase, lowercase, digit, and
 * special character (@$!%*?&).
 */
export class InsuredLoginRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.username = raw.username ?? ""; // Insured email address (used as username).
    /** @type {string} */
    this.password = raw.password ?? ""; // Account password. Min 6 characters; must include upper and lower case, a digit, and a spec...
  }
}

/**
 * Google ID token for SSP sign-in (`POST .../auth/sign-in-with-google`).
 */
export class GoogleTokenRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.googletoken = raw.googletoken ?? ""; // Google ID token (JWT) from client sign-in.
  }
}

export class GoogleTokenResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.clientId = raw.clientId ?? "";
  }
}

export class GoogleDataResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.firstname = raw.firstname ?? "";
    /** @type {string} */
    this.lastname = raw.lastname ?? "";
    /** @type {string} */
    this.email = raw.email ?? "";
  }
}

/**
 * Validate password-reset link token (`POST .../auth/password/change`).
 */
export class ChangePasswordRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.token = raw.token ?? ""; // Password-reset token from email link.
  }
}

export class ChangePasswordResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {boolean} */
    this.valid = raw.valid ?? false;
    /** @type {string} */
    this.email = raw.email ?? "";
  }
}

/**
 * Forgot password (`POST .../auth/password/forgot`). **404** if email not
 * registered.
 */
export class ForgotPasswordRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.email = raw.email ?? ""; // Insured account email (username).
    /** @type {string} */
    this.clientId = raw.clientId ?? ""; // Optional broker/client identifier for email template routing.
  }
}

/**
 * Complete password reset (`POST .../auth/password/update`).
 */
export class UpdatePasswordRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.token = raw.token ?? ""; // Password-reset token from email link.
    /** @type {string} */
    this.newpassword = raw.newpassword ?? ""; // New password (6–128 characters). Must include upper and lower case, a digit, and a special...
  }
}

export class UpdatePasswordResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {boolean} */
    this.updated = raw.updated ?? false;
  }
}

export class MessageResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.code = raw.code ?? 0;
    /** @type {string} */
    this.message = raw.message ?? "";
  }
}

export class BrokersResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.name = raw.name ?? "";
    /** @type {SpecialityIdAndClientUrl[]} */
    this.brokerspecialities = Array.isArray(raw.brokerspecialities) ? raw.brokerspecialities.map((x) => new SpecialityIdAndClientUrl(x)) : [];
    /** @type {string} */
    this.brokerAbbrivation = raw.brokerAbbrivation ?? "";
    /** @type {string[]} */
    this.brokerProfile = Array.isArray(raw.brokerProfile) ? raw.brokerProfile : [];
  }
}

export class SpecialityMasterResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.title = raw.title ?? "";
    /** @type {string} */
    this.abbreviation = raw.abbreviation ?? "";
    /** @type {string} */
    this.specialitiesCategory = raw.specialitiesCategory ?? "";
    /** @type {string} */
    this.description = raw.description ?? "";
    /** @type {string} */
    this.speiclaityRandomCode = raw.speiclaityRandomCode ?? "";
  }
}

export class SpecialitiesCategoryResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.name = raw.name ?? "";
  }
}

export class SpecialityIdAndClientUrl {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.speiclaityRandomCode = raw.speiclaityRandomCode ?? "";
  }
}

export class SpecialityFactorTypeResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.factortype = raw.factortype ?? "";
  }
}

export class ZipcodeDetailsRespose {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.st = raw.st ?? "";
    /** @type {string} */
    this.county = raw.county ?? "";
    /** @type {string} */
    this.state = raw.state ?? "";
    /** @type {string} */
    this.city = raw.city ?? "";
    /** @type {string} */
    this.defense = raw.defense ?? "";
  }
}
